import React from 'react';

export const ArrowLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.153119 5.37801L4.55388 9.84536C4.78072 10.0515 5.12098 10.0515 5.32514 9.84536L5.84688 9.31844C6.05104 9.11226 6.05104 8.76861 5.84688 8.53952L2.3535 4.98855L5.84688 1.46048C6.05104 1.23139 6.05104 0.887743 5.84688 0.681558L5.32514 0.154639C5.12098 -0.0515464 4.78072 -0.0515464 4.55388 0.154639L0.153119 4.62199C-0.0510397 4.82818 -0.0510397 5.17182 0.153119 5.37801Z"
      fill="#AAAAAA"
    />
  </svg>
);
